'use client';

import { Button, Grid, Heading, Stack, Text } from '@cortex/ui';
import { Check, X } from 'lucide-react';

import { QUESTION_ENTER_ANIMATION } from './styles';
import type { ConfirmationQuestionProps } from './types';

export function ConfirmationQuestion({
  acknowledgment,
  question,
  yesLabel = "Yes, that's correct",
  noLabel = 'No, let me clarify',
  onConfirm,
  onDecline,
}: ConfirmationQuestionProps) {
  return (
    <Stack gap="lg" className={QUESTION_ENTER_ANIMATION}>
      {acknowledgment && (
        <Text color="muted" size="sm" className="italic">
          {acknowledgment}
        </Text>
      )}

      <Heading level={3} className="text-lg font-medium">
        {question}
      </Heading>

      <Grid columns={1} gap="sm" className="sm:grid-cols-2">
        <Button
          onClick={onConfirm}
          size="lg"
          variant="default"
          className="h-auto flex-col gap-2 py-4"
        >
          <Check className="h-5 w-5" />
          <Text as="span">{yesLabel}</Text>
        </Button>
        <Button
          onClick={onDecline}
          size="lg"
          variant="outline"
          className="h-auto flex-col gap-2 py-4"
        >
          <X className="h-5 w-5" />
          <Text as="span">{noLabel}</Text>
        </Button>
      </Grid>
    </Stack>
  );
}
